import type {
  SupplierRelationshipActivityCreateRequestType,
  SupplierRelationshipActivityCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRelationshipActivityCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierRelationshipActivityCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `supplier-relationship-activities`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierRelationshipActivityCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SupplierRelationshipActivities,
        ],
      });
    },
  });
};
